export const msalAuthConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_CLIENT_ID}`,
    authority: `${process.env.REACT_APP_AUTH_AUTHORITY}`,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUri: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [`${process.env.REACT_APP_API_SCOPE}`],
};
